import { THIS_WEEK, LAST_WEEK, NEXT_WEEK, TWO_WEEKS, RESET } from 'settings/constants/datePicker'

export const shortcutsItems = [{ ...THIS_WEEK }, { ...LAST_WEEK }, { ...NEXT_WEEK }, { ...TWO_WEEKS }, { ...RESET }]
